import { Component, Input } from '@angular/core';
import { GenericBulkUpsertRecord, GenericValidationError, GenericFieldChange, GenericBulkUpsertAction } from '../models/generic-bulk-upsert.model';

@Component({
  selector: 'generic-validation-table',
  templateUrl: './validation-table.component.html'
})
export class GenericValidationTableComponent {
  @Input() records: GenericBulkUpsertRecord[] = [];
  @Input() errors: GenericValidationError[] = [];
  @Input() changes: GenericFieldChange[] = [];
  @Input() fields: import('../models/generic-bulk-upsert.model').GenericBulkUpsertField[] = [];

  // Pagination
  currentPage = 1;
  pageSize = 15;

  get pagedRecords(): GenericBulkUpsertRecord[] {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    return this.records.slice(start, end);
  }

  onPageChange(page: number): void {
    this.currentPage = page;
  }

  onPageSizeChange(size: number): void {
    this.pageSize = size;
    this.currentPage = 1;
  }

  getFieldValue(record: GenericBulkUpsertRecord, fieldKey: string): string {
    return (record as any)[fieldKey] || '';
  }

  hasError(rowIndex: number, fieldKey: string): boolean {
    return this.errors.some(e => e.rowIndex === rowIndex && e.field === fieldKey);
  }

  getErrorMessages(rowIndex: number, fieldKey: string): string {
    return this.errors
      .filter(e => e.rowIndex === rowIndex && e.field === fieldKey)
      .map(e => e.errorMessage)
      .join(', ');
  }


  isChanged(rowIndex: number, fieldKey: string): boolean {

    var hasError = this.hasError(rowIndex, fieldKey);
    if (hasError) {
      return false;
    }

    return this.changes.some(c => c.rowIndex === rowIndex && c.field === fieldKey);
  }

  getChangeTooltip(rowIndex: number, fieldKey: string): string {
    const change = this.changes.find(c => c.rowIndex === rowIndex && c.field === fieldKey);
    if (change) {
      return `Will change from "${change.oldValue}" to "${change.newValue}"`;
    }
    return '';
  }

  getCellTitle(rowIndex: number, fieldKey: string): string {
    const errorMessages = this.getErrorMessages(rowIndex, fieldKey);
    const changeTooltip = this.getChangeTooltip(rowIndex, fieldKey);
    return errorMessages || changeTooltip || '';
  }

  hasRowErrors(rowIndex: number): boolean {
    return this.errors.some(e => e.rowIndex === rowIndex);
  }

  getActionLabel(record: GenericBulkUpsertRecord): string {
    let action = 'No Change';
    
    if (record.action === GenericBulkUpsertAction.Update) {
      action = 'Update';
    } else if (record.action === GenericBulkUpsertAction.Create) {
      action = 'Create';
    }

    return action;
  }
}
